/**
 * All anchor positions that drawer supports.
 */
export enum DrawerPosition {
    BOTTOM = 'bottom',
    LEFT = 'left',
    RIGHT = 'right',
    TOP = 'top'
}
